module.exports = __webpack_public_path__ + "images/bug_wine_red_large_0b0fde4e25251ab88a9bded78a0d6e1b.png";